<!--
todo 3: Either use routes or give warning when trying to exit. Use cas: click back button and loses whole form..
todo 4: Add a radial stepper: https://medium.com/@uxmovement/how-to-display-steppers-on-mobile-forms-29d4cf91f4fd
-->
<div *ngIf="loadingSelfServiceStatus">
  <nk-spinner size="lg"></nk-spinner>
</div>

<div *ngIf="!loadingSelfServiceStatus">
  <div *ngIf="!enableSelfService">
    <div class="style-flex mt-5">
      <div class="m-auto" style="width: 500px">
        <h1>
          {{ 'sign_up.self_service_is_not_supported' | translate }}
        </h1>
      </div>
    </div>
  </div>
  <div *ngIf="enableSelfService">
    <div class="style-flex mt-5">
      <div class="m-auto" style="width: 500px">
        <nk-spinner *ngIf="isLoggedIn === null" size="lg"></nk-spinner>
        <nk-card *ngIf="isLoggedIn === true">
          <div class="card-body">
            <div class="p-2">
              <h3>
                {{ 'sign_up.you_must_be_logged_out_before_registering' | translate }}
              </h3>
              <p class="text-muted">
                {{ 'sign_up.new_unique_email_for_self_service_onboarding' | translate }}
              </p>
              <p class="text-muted" [innerHtml]="'sign_up.new_account_with_your_existing_email_help' | translate"></p>
              <button nkButton color="primary" (click)="onLogout()">
                {{ 'sign_up.logout' | translate }}
              </button>
            </div>
          </div>
        </nk-card>
        <nk-card *ngIf="isLoggedIn === false">
          <div class="card-body">
            <div class="p-2">
              <div class="mb-5">
                <img src="app/assets/img/logo_black.svg" class="animated fadeIn mb-4" height="19" />
                <h3 [innerHtml]="'sign_up.create_account_header' | translate: { trialPeriod: trialPeriod }"></h3>
              </div>
              <!--See app routing, under sign-up children-->
              <router-outlet> </router-outlet>
            </div>
            <button
              *ngIf="setupStage > 0"
              type="submit"
              nkButton
              [color]="'link'"
              andClass="wiz-nav"
              (click)="onPrevClick()">
              <i class="fa fa-arrow-left me-2"></i>
              {{ 'sign_up.previous_btn' | translate }}
            </button>

            <button
              *ngIf="setupStage < stageList.length - 1"
              type="submit"
              nkButton
              [color]="'success'"
              andClass="wiz-nav float-end"
              [class.disabled]
              (click)="onNextClick()">
              {{ 'sign_up.next_btn' | translate }} <i class="ms-2 fa fa-arrow-right"></i>
            </button>
          </div>
        </nk-card>
      </div>
    </div>
  </div>
</div>
